import { getTelcos, getDataCategories, getDataServices } from '@/api/airtime-data'

const actions = {
    FETCH_TELCOS: ({ commit }) => {
        getTelcos()
            .then((data) => {
                commit('COMMIT_TELCOS', data.data.data.availabletelco)
            })
            .catch((err) => {
                console.dir(err)
            })
    },

    FETCH_DATA_CATEGORIES: ({ commit }) => {
        getDataCategories()
            .then((data) => {
                const responseData = data.data.data
                commit('COMMIT_DATA_CATEGORIES', responseData)

                responseData.forEach((_data) => {
                    getDataServices(_data.serviceID).then((__data) => {
                        const res = __data.data.data
                        commit('COMMIT_DATA_SERVICES', { data: res, id: _data.serviceID })
                    })
                })
            })
            .catch((err) => {
                console.dir(err)
            })
    },
}

export default actions
